import "./App.scss";
import "./App.less";
import React, {useState, useContext, useEffect, useMemo, Suspense} from 'react';
import {Switch, Route, Redirect, useHistory, useLocation} from "react-router-dom";
import {Layout}          from 'antd';
import pages             from "@page/index.js";
import ws_socket         from "@tools/web_socket";
import lookups           from "@tools/lookups.json";
import GlobalNav         from "@components/global_navigation/GlobalNav";
import LayoutContext     from "@components/contexts/LayoutContext";
import GlobalContext     from "@components/contexts/GlobalContext.js";
import LoadingPage       from "@components/loading_page/LoadingPage";
import MailingResultInfo from "@components/MailingResultInfo";
import {CompanyLink}     from "@tools/LinkGenerator";
import useUserRights     from "@hooks/useUserRights";

const { Content } = Layout;
const branches = lookups.obj.fuel_user.branch;

const AppUser = (props) => {
    const [compactMenu, setCompactMenu] = useState(true);
    const {checkVisiblePages} = useUserRights();
    const {state, dispatch} = useContext(GlobalContext);
    const {userCompanies, company} = state;
    const history = useHistory();
    const location = useLocation();

    const siderNormalWidth = 256;
    const siderCompactWidth = 52;

    const isGasStation = userCompanies.some(item => (item.category || []).includes(lookups.obj.fuel_facility.category.gas_station_company))
    // const isCarrierCompany = userCompanies.some(item => (item.category || []).includes(lookups.obj.fuel_facility.category.gas_station_company))
    const companyBranch = isGasStation ? [branches.gas_station_company] : [branches.carrier_company, branches.price_analysis, branches.invoice]
    const visiblePages = checkVisiblePages()
    let allowPages = visiblePages.filter(page => [branches.alert, branches.help_center, ...companyBranch, branches.tracker].includes(page.id));

    useEffect(() => {
        const path = location.pathname.split("/")
        const isMainPage = [lookups.obj.fuel_user.branch.carrier_company, lookups.obj.fuel_user.branch.gas_station_company].some(it => path.includes(it)) 
        if(isMainPage && !path.includes(userCompanies[0]._id)) {
            history.replace(CompanyLink(userCompanies[0]))
        }
    }, [company, location, history])

    useEffect(() => {
        let socket = ws_socket.on("message", (data) => {
            dispatch({type : "add_socket_event", value: {[data.data._id] : data}});
        });

        return (() => socket.off())
    }, [dispatch]);


    const Home = useMemo(() => {
        let url = "/"
        const mainCompany = userCompanies.find(item => (item.type || []).includes(lookups.obj.fuel_facility.type.main_company))
        const gasStation = userCompanies.find(item => (item.type || []).includes(lookups.obj.fuel_facility.type.gas_station))


        if(gasStation)
            url = CompanyLink(gasStation) /*`/${lookups.obj.fuel_facility.category.gas_station_company}/${mainCompany._id}/gas_station/${gasStation._id}/info`*/
        else
            url = CompanyLink(mainCompany)

         return <Redirect to={url}/>
    }, [userCompanies]);

    const NotFound = useMemo(() => pages.not_found, []);

    return (
        <LayoutContext.Provider value={
            {
                compactMenu,
                setCompactMenu,
                siderNormalWidth,
                siderCompactWidth,
            }
        }>
            <Layout>
                <MailingResultInfo />
                <GlobalNav menus={allowPages} cbLogout={props.cbLogout} hideHomeButton={true}/>
                <Layout style={{ marginLeft: compactMenu ? siderCompactWidth : siderNormalWidth }}>
                    <Content>
                        <Suspense fallback={<LoadingPage />}>
                            <Switch>
                                <Route exact path="/">
                                    {Home}
                                </Route>
                                {
                                    visiblePages.map(({ url, id }) => {
                                        const Page = pages[ id ] || NotFound;
                                        return (
                                            <Route
                                                path={url}
                                                key={id}
                                            >
                                                <Page id={id}/>
                                            </Route>
                                        )
                                    })
                                }
                                <Route path="*">
                                    <NotFound />
                                </Route>
                            </Switch>

                        </Suspense>
                    </Content>
                </Layout>
            </Layout>
        </LayoutContext.Provider>
    )
};

export default AppUser
